module.exports = __webpack_public_path__ + "media/images/lb/277-11c1c13abac4ae8279026f04651d41d2.svg";